let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("aVsRz")]).then(() => parcelRequire('fydRE'));